import React, {Fragment} from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import { connect } from "react-redux";
import { compose } from "redux";
import queryString from 'query-string'
import { Tab, Typography, Grid, Card, CardContent, Collapse } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { withRouter} from "react-router-dom";
import { ButtonText, GUEST_PERMISSIONS, LOAN_SENIORITY_TYPES, MaterialIcon } from "@loanbossinc/component-library";

import ButtonMenu from "./ButtonMenu";
import PageTitle from "components/Global/PageOrganization/PageTitle";
import SecondaryButton from "components/Global/Buttons/SecondaryButton";
import { getDealName } from "store/state/deal";
import { getFundName } from "store/state/fund";
import {
  getCombinedQuoteCashflows,
  getQuoteCashflows,
  getDealCashflows,
  downloadLoanCashflows,
  downloadHedgeCashflows,
  resetHedgeCashflowOverrides,
  resetLoanCashflowOverrides,
  downloadCombinedCashflows,
  uploadLoanCashflowsOverride,
  uploadHedgeCashflowsOverride,
  getDebtValuationActivationStatus
} from "store/state/cashflows";
import { downloadDebtValuationResultsByLoanId, getRatesAsOfForLoans } from "../../pages/debtValuation/debtValuation.store";
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog";
import OverrideCashflowsModal from "./OverrideCashflowsModal";
import DebtValuationSettingsModal from "./DebtValuationSettingsModal";
import DownloadPrincipalTemplate from "./DownloadPrincipalTemplate";
import DownloadPrincipalAndInterestPaymentTemplate from "./DownloadPrincipalAndInterestPaymentTemplate";
import DownloadCapTemplate from "./DownloadCapTemplate";
import DownloadSwapTemplate from "./DownloadSwapTemplate";
import DownloadCollarTemplate from "./DownloadCollarTemplate";
import DownloadCorridorTemplate from "./DownloadCorridorTemplate";
import LoanCashflows from "./LoanCashflows";
import DebtValuationCashflows from "./DebtValuationCashflows";
import CombinedCashflows from "./CombinedCashflows";
import SwapCashflows from "./SwapCashflows";
import CorridorCashflows from "./CorridorCashflows";
import CapCashflows from "./CapCashflows";
import FloorCashflows from "./FloorCashflows";
import CollarCashflows from "./CollarCashflows";
import { CLOSED_LOAN, QUOTE, IN_CLOSING } from "constants/loanStatuses";
import hedgeStatus from "constants/hedgeStatus";
import {
  COMBINED_CASHFLOW,
  LOAN_CASHFLOW,
  SWAP_CASHFLOW,
  CORRIDOR_CASHFLOW,
  CAP_CASHFLOW,
  COLLAR_CASHFLOW,
  FLOOR_CASHFLOW,
  HEDGE_CASHFLOW,
  DEBT_VALUATION
} from "constants/cashflowTypes";

import guestPermissionHelper from "utils/guestPermissionHelper";
import DebtValuationExportModal from "../../pages/debtValuation/DebtValuationExportModal";

const styles = (_theme) => ({
  tabRoot: {
    minWidth: "300px"
  },
  tabsRoot: {
    flexBasis: "100%"
  }
});
const CashflowsTabButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const OverrideButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 32px;
  justify-content: flex-end;
`;

const DownloadTemplateSeparator = styled.div`
  & {
    max-height: 48px;
  }
`;
const StyledTab = styled(Tab)`
  && {
    color: #009ddf;
    border-bottom: 1px solid #009ddf;
  }
`;

const CashflowsTitle = styled(PageTitle)`
  & {
    margin-top: 12px;
    margin-bottom: 12px;
  }
`;
const StyledDebtValuationMetricContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 1032px;
  height: 130px;
  filter: drop-shadow(0px 10px 20px rgba(173, 174, 174, 0.25));
  background: #ffffff;
  border: 1px solid #dadce0;
  box-sizing: border-box;
  border-radius: 0px;
`;
const DVMetric = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;
const DVMetricValue = styled.div`
  font-family: Space Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
  color: ${(props) => (props.isNegative ? "#C40A0A" : "#005AA9")};
`;
const DVTitleLabel = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  color: #000000;
  width: 100%;
`;
const DVLink = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #005aa9;
  cursor: pointer;
  margin-top: 10px;
  width: 100%;
`;
const DVMetricDivider = styled.div`
  width: 0;
  height: 100%;
  border: 1px solid #dadce0;
  background: #dadce0;
`;
const DVMetricLabel = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #5f6368;
`;
const DVAsOfDateLabel = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #5f6368;
  margin-top: 14px;
  width: 100%;
`;

const StyledDebtValuationContainer = styled(Collapse)`
  margin-left: auto;
  margin-right: auto;
  margin-top: ${(props) => {
    return props.addMargin ? "42px" : "0";
  }};
  margin-bottom: ${(props) => (props.addMargin ? "44px" : "0")};
`;

const tableContainerStyles = {
  width: "100%",
  "overflow-y": "auto",
  "max-height": "56vh",
  "box-shadow": "0px 10px 20px rgba(173, 174, 174, 0.25)",
  borderBottom: "1px solid #DADADA",
  "border-radius": "8px"
};
function TabContainer(props) {
  return (
    <Typography component="div" style={{ width: "100%" }}>
      {props.children}
    </Typography>
  );
}
class CashflowsPage extends React.Component {
  state = {
    value: false,
    isResetModalOpen: false,
    isOverrideCashflowModalOpen: false,
    selectedCashflows: [],
    isDVStateActive: false,
    isDebtValuationSettingsModalOpen: false,
    isExportModalOpen: false,
    valuationDate: moment().format("YYYY-MM-DD")
  };

  componentDidMount() {
    const { location, match } = this.props;
    const params = queryString.parse(location.search, { arrayFormat: "bracket" });
    const fundId = match.params.fundId;
    const dealId = match.params.dealId;
    this.props.getDealName({ dealId: dealId, subKey: dealId });
    this.setState({
      quoteId: params.loanId,
      quoteId2: params.loanId2,
      dealId: dealId,
      fundId: fundId,
      shouldShowActive: Boolean(params.active),
      loanId: params.loanId,
      showActiveLoans: params.showActiveLoans,
      showActiveHedges: params.showActiveHedges,
      showQuotes: params.showQuotes,
      hedgeId: params.hedgeId,
      value: false
    });
    this.props.getDebtValuationActivationStatus();
    if (params.showQuotes) {
      if (params.loanId2) {
        this.props.getCombinedQuoteCashflows({ dealId, subKey: dealId, quoteId1: params.loanId, quoteId2: params.loanId2 });
      } else {
        this.props.getQuoteCashflows({ dealId, quoteId: params.loanId, subKey: dealId });
      }
    } else {
      this.props.getDealCashflows({ dealId: dealId, subKey: dealId });
    }
    this.props.getRatesAsOfForLoans({ dealId });
  }

  componentDidUpdate(prevProps, prevState) {
    const { location } = this.props;
    const params = queryString.parse(location.search, { arrayFormat: "bracket" });
    const { value, loanId, hedgeId, quoteId } = this.state;
    const { value: prevValue } = prevState;
    const { cashflows, uploadResult } = this.props;
    const { cashflows: prevCashflows, uploadResult: prevUploadResult } = prevProps;
    if (cashflows !== prevCashflows) {
      let cashflowRecords = this.getCashflows();
      let selectedValue = this.state.showQuotes && loanId ? `LOAN_CASHFLOW${quoteId}` : this.getValue(value, loanId || quoteId, hedgeId, cashflowRecords);
      if (params.isDebtValuation) {
        selectedValue = `DV_${selectedValue}`;
        this.handleDebtValuationToggle(true);
      }
      this.setState({ value: selectedValue });
    } else if (value !== prevValue || cashflows !== prevCashflows) {
      this.calculateSelectedValueCashflows(value);
    }
    if (uploadResult !== prevUploadResult && uploadResult.wasSuccessful) {
      this.closeOverrideCashflowModal();
    }

    if (this.props.dealNames[Number(this.state.dealId)]) {
      if (prevState.dealName != this.props.dealNames[Number(this.state.dealId)].name) {
        const dealName = this.props.dealNames[Number(this.state.dealId)].name;
        let state = this.state;
        this.state.dealName = dealName;
        this.setState(state);
      }
    }
  }

  handleChange = (event, value) => {
    let state = this.state;
    state.value = value;
    this.setState(state);
  };

  handleDebtValuationToggle = (isDVStateActive) => {
    this.setState({ isDVStateActive });
  };

  handleOverride = (file, selectedCashflowObject) => {
    if (selectedCashflowObject.type === LOAN_CASHFLOW) {
      this.props.uploadLoanCashflowsOverride({
        file: file[0],
        dealId: this.state.dealId,
        loanId: selectedCashflowObject.id
      });
    } else if (selectedCashflowObject.type !== LOAN_CASHFLOW && selectedCashflowObject.type !== COMBINED_CASHFLOW) {
      this.props.uploadHedgeCashflowsOverride({
        file: file[0],
        hedgeId: selectedCashflowObject.id,
        dealId: this.state.dealId
      });
    }
  };

  openOverrideCashflowModal = () => {
    this.setState({ isOverrideCashflowModalOpen: true });
  };

  closeOverrideCashflowModal = () => {
    this.setState({ isOverrideCashflowModalOpen: false });
  };

  openResetModal = () => {
    this.setState({ isResetModalOpen: true });
  };

  closeResetModal = () => {
    this.setState({ isResetModalOpen: false });
  };

  handleDebtValuationSettingsModal = () => {
    this.setState({ isDebtValuationSettingsModalOpen: !this.state.isDebtValuationSettingsModalOpen });
  };

  handleResetOverride = (selectedCashflowObject) => {
    if (selectedCashflowObject.type === LOAN_CASHFLOW) {
      this.props.resetLoanCashflowOverrides({ loanId: selectedCashflowObject.id, dealId: this.state.dealId });
    }
    if (selectedCashflowObject.type !== LOAN_CASHFLOW && selectedCashflowObject.type !== COMBINED_CASHFLOW) {
      this.props.resetHedgeCashflowOverrides({ hedgeId: selectedCashflowObject.id, dealId: this.state.dealId });
    }
    this.setState({ isResetModalOpen: false });
  };

  calculateSelectedValueCashflows = (value) => {
    let cashflowsRecords = this.getCashflows();
    let selectedCashflows = this.getSelectedValueCashflows(value, cashflowsRecords);
    this.setState({ selectedCashflows });
  };

  generateTabs = (cashflows) => {
    const sorted = this.sortLoanCashflows(cashflows);

    if (_.isEmpty(sorted)) {
      return null;
    }
    return sorted.reduce((acc, val) => {
      const loanSeniority = _.get(val, "seniority");
      const closingDate = _.get(val, "closingDate");
      const closingYear = closingDate ? closingDate.slice(0, 4) : null;
      const name = loanSeniority && closingYear ? `${val.name} - ${loanSeniority} - ${closingYear}` : `${val.name}`;
      const loan = {
        id: `${val.type}${val.id}`,
        name: name,
        data: val
      };
      if (this.isHedge(val.type)) {
        if (!acc[HEDGE_CASHFLOW]) {
          acc[HEDGE_CASHFLOW] = [];
        }
        acc[HEDGE_CASHFLOW].push(loan);
        return acc;
      }

      if (this.hasDebtValuation(val.type)) {
        if (!acc[DEBT_VALUATION]) {
          acc[DEBT_VALUATION] = [];
        }
        acc[DEBT_VALUATION].push({
          ...loan,
          id: `DV_${loan.id}`
        });
      }

      if (!acc[val.type]) {
        acc[val.type] = [];
      }
      acc[val.type].push(loan);
      return acc;
    }, {});
  };

  sortLoanCashflows = (cashflows) => {
    if (!cashflows || cashflows.length === 0) return [];

    const loanCashflows = cashflows.filter((x) => x.type === "LOAN_CASHFLOW");
    const otherCashflows = cashflows.filter((x) => x.type !== "LOAN_CASHFLOW");
    const sortedloanCashflows = this.sortBySeniority(loanCashflows);

    return [...sortedloanCashflows, ...otherCashflows];
  };

  sortBySeniority = (loans) => {
    if (loans && loans.length > 0) {
      const sortedLoans = [];
      const lienPriorities = new Set();
      loans.forEach((x) => lienPriorities.add(x.lienPriority));
      const iterableLienPriorities = [...lienPriorities].sort();

      for (const priority of iterableLienPriorities) {
        const filtered = loans.filter((x) => x.lienPriority === priority);
        const sortedArray = this.addToSortedLoans(filtered);
        sortedLoans.push(...sortedArray);
      }

      return sortedLoans;
    }
  };

  addToSortedLoans = (loans) => {
    const sortedLoans = [];
    const filteredSenior = loans.filter((x) => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SENIOR);
    const filteredSubordinate = loans.filter((x) => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SUBORDINATE);
    const filteredSubsidy = loans.filter((x) => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SUBSIDY);
    const filteredSupplemental = loans.filter((x) => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SUPPLEMENTAL);

    if (filteredSenior.length > 0)
      sortedLoans.push(...filteredSenior.sort((a, b) => a.id - b.id).sort((a, b) => new Date(a.closingDate) - new Date(b.closingDate)));
    if (filteredSubordinate.length > 0)
      sortedLoans.push(...filteredSubordinate.sort((a, b) => a.id - b.id).sort((a, b) => new Date(b.closingDate) - new Date(a.closingDate)));
    if (filteredSubsidy.length > 0)
      sortedLoans.push(...filteredSubsidy.sort((a, b) => a.id - b.id).sort((a, b) => new Date(b.closingDate) - new Date(a.closingDate)));
    if (filteredSupplemental.length > 0)
      sortedLoans.push(...filteredSupplemental.sort((a, b) => a.id - b.id).sort((a, b) => new Date(b.closingDate) - new Date(a.closingDate)));
    return sortedLoans;
  };

  createContainer = (value, cashflowObject, Component, onExport) => {
    return (
      value == cashflowObject.type + cashflowObject.id && (
        <TabContainer key={cashflowObject.type + cashflowObject.id}>
          <Component cashflows={cashflowObject.cashflows} onExport={onExport} />
        </TabContainer>
      )
    );
  };

  renderDownloadElements = (selectedCashflowObject) => {
    if (!selectedCashflowObject) {
      return null;
    }
    if (selectedCashflowObject.type === LOAN_CASHFLOW) {
      return (
        <Fragment>
          <DownloadTemplateSeparator>
            <DownloadPrincipalTemplate loanId={selectedCashflowObject.id} />
          </DownloadTemplateSeparator>
          <DownloadTemplateSeparator>
            <DownloadPrincipalAndInterestPaymentTemplate loanId={selectedCashflowObject.id} />
          </DownloadTemplateSeparator>
        </Fragment>
      );
    } else if (selectedCashflowObject.type === SWAP_CASHFLOW) {
      return (
        <Fragment>
          <DownloadTemplateSeparator>
            <DownloadSwapTemplate hedgeId={selectedCashflowObject.id} />
          </DownloadTemplateSeparator>
        </Fragment>
      );
    } else if (selectedCashflowObject.type === COLLAR_CASHFLOW) {
      return (
        <Fragment>
          <DownloadTemplateSeparator>
            <DownloadCollarTemplate hedgeId={selectedCashflowObject.id} />
          </DownloadTemplateSeparator>
        </Fragment>
      );
    } else if (selectedCashflowObject.type === CAP_CASHFLOW) {
      return (
        <Fragment>
          <DownloadTemplateSeparator>
            <DownloadCapTemplate hedgeId={selectedCashflowObject.id} />
          </DownloadTemplateSeparator>
        </Fragment>
      );
    } else if (selectedCashflowObject.type === CORRIDOR_CASHFLOW) {
      return (
        <Fragment>
          <DownloadTemplateSeparator>
            <DownloadCorridorTemplate hedgeId={selectedCashflowObject.id} />
          </DownloadTemplateSeparator>
        </Fragment>
      );
    } else {
      return null;
    }
  };

  getSelectedValueCashflows = (value, dealCashflows) => {
    return _.get(this.getSelectedValueCashflowObject(value, dealCashflows), "cashflows", []);
  };

  getSelectedValueCashflowObject = (value, dealCashflows) => {
    return _.find(dealCashflows, (o) => o.type + o.id === value, {});
  };

  createCombinedContainer = (value, cashflowObject) => {
    let payload = {
      dealId: this.state.dealId,
      isQuote: this.state.showQuotes,
      cashflowObject
    };
    return this.createContainer(value, cashflowObject, CombinedCashflows, () => this.props.downloadCombinedCashflows(payload));
  };
  createLoanContainer = (value, cashflowObject) => {
    let payload = {
      dealId: this.state.dealId,
      loanId: cashflowObject.id
    };
    return this.createContainer(value, cashflowObject, LoanCashflows, () => this.props.downloadLoanCashflows(payload));
  };
  createDebtValuationContainer = (value, cashflowObject) => {
    let payload = {
      dealId: this.state.dealId,
      loanId: cashflowObject.id
    };
    return this.createContainer(value.split("DV_")[1], cashflowObject, DebtValuationCashflows, () => this.props.downloadLoanCashflows(payload));
  };
  createSwapContainer = (value, cashflowObject) => {
    let payload = {
      dealId: this.state.dealId,
      hedgeId: cashflowObject.id,
      cashflowType: cashflowObject.type,
      fromQuote: this.state.showQuotes,
      cashflowObject
    };
    return this.createContainer(value, cashflowObject, SwapCashflows, () => this.props.downloadHedgeCashflows(payload));
  };
  createCorridorContainer = (value, cashflowObject) => {
    let payload = {
      dealId: this.state.dealId,
      hedgeId: cashflowObject.id,
      cashflowType: cashflowObject.type,
      fromQuote: this.state.showQuotes,
      cashflowObject
    };
    return this.createContainer(value, cashflowObject, CorridorCashflows, () => this.props.downloadHedgeCashflows(payload));
  };
  createCollarContainer = (value, cashflowObject) => {
    let payload = {
      dealId: this.state.dealId,
      hedgeId: cashflowObject.id,
      cashflowType: cashflowObject.type,
      fromQuote: this.state.showQuotes,
      cashflowObject
    };
    return this.createContainer(value, cashflowObject, CollarCashflows, () => this.props.downloadHedgeCashflows(payload));
  };
  createCapContainer = (value, cashflowObject) => {
    let payload = {
      dealId: this.state.dealId,
      hedgeId: cashflowObject.id,
      cashflowType: cashflowObject.type,
      fromQuote: this.state.showQuotes,
      cashflowObject
    };
    return this.createContainer(value, cashflowObject, CapCashflows, () => this.props.downloadHedgeCashflows(payload));
  };
  createFloorContainer = (value, cashflowObject) => {
    let payload = {
      dealId: this.state.dealId,
      hedgeId: cashflowObject.id,
      cashflowType: cashflowObject.type,
      fromQuote: this.state.showQuotes,
      cashflowObject
    };
    return this.createContainer(value, cashflowObject, FloorCashflows, () => this.props.downloadHedgeCashflows(payload));
  };
  generateTabContainers = (value, cashflows) => {
    if (_.isEmpty(cashflows)) {
      return null;
    }
    return cashflows.map((x) => {
      switch (x.type) {
        case COMBINED_CASHFLOW:
          return this.createCombinedContainer(value, x);
        case LOAN_CASHFLOW:
          if (value && value.indexOf("DV") !== -1) {
            return this.createDebtValuationContainer(value, x);
          }
          return this.createLoanContainer(value, x);
        case SWAP_CASHFLOW:
          return this.createSwapContainer(value, x);
        case CORRIDOR_CASHFLOW:
          return this.createCorridorContainer(value, x);
        case COLLAR_CASHFLOW:
          return this.createCollarContainer(value, x);
        case CAP_CASHFLOW:
          return this.createCapContainer(value, x);
        case FLOOR_CASHFLOW:
          return this.createFloorContainer(value, x);
        default:
          return null;
      }
    });
  };

  generateDVData = (value, cashflows) => {
    if (_.isEmpty(cashflows)) {
      return null;
    }
    const typeId = value && value.indexOf("DV") !== -1 ? value.split("DV_")[1] : value;

    const result = _.find(cashflows, (x) => typeId == x.type + x.id, {});
    if (result) {
      const ratesAsOfRecord = this.props.ratesAsOfForLoans.find((x) => x.loanId === result.id);
      return {
        debtValue: result.debtValue,
        parValue: result.parValue,
        discountPremium: result.discountPremium,
        debtValuationSettings: result.debtValuationSettings,
        ratesAsOf: ratesAsOfRecord ? ratesAsOfRecord.rateAsOf : null
      };
    }
    return null;
  };

  getCashflows = () => {
    const { dealId, loanId, hedgeId, showActiveLoans, showActiveHedges } = this.state;
    const { cashflows } = this.props;
    let cashflow_records = _.get(cashflows, `[${dealId}]`, []);
    if (this.state.showQuotes) {
      return cashflow_records;
    }
    if (loanId && !showActiveLoans) {
      return cashflow_records.filter((x) => x.id == loanId && x.type === LOAN_CASHFLOW);
    } else if (showActiveLoans) {
      cashflow_records = cashflow_records.filter(this.filterActive);
    } else if (showActiveHedges) {
      cashflow_records = cashflow_records.filter(this.filterActive);
    } else if (hedgeId && !showActiveHedges) {
      return cashflow_records.filter((x) => x.id == +hedgeId && this.isHedge(x.type));
    }
    return cashflow_records.filter(this.filterActive);
  };

  filterActive = (x) => {
    if (x.type === COMBINED_CASHFLOW) {
      return true;
    } else if (x.type === LOAN_CASHFLOW) {
      return !this.state.showQuotes ? x.status === CLOSED_LOAN && !!x.seniority : (x.status === QUOTE || x.status === IN_CLOSING) && x.seniority;
    } else if (this.isHedge(x.type)) {
      return x.status === hedgeStatus.ACTIVE;
    }
    return false;
  };

  isHedge = (cashflowType) => {
    return (
      cashflowType === CAP_CASHFLOW ||
      cashflowType === COLLAR_CASHFLOW ||
      cashflowType === SWAP_CASHFLOW ||
      cashflowType === CORRIDOR_CASHFLOW ||
      cashflowType === FLOOR_CASHFLOW
    );
  };

  hasDebtValuation = (cashflowType) => {
    return cashflowType === LOAN_CASHFLOW;
  };

  getValue = (value, loanId, hedgeId, cashflows) => {
    if (_.isEmpty(cashflows)) {
      return false;
    }
    if (value !== false) {
      return value;
    }
    if (loanId) {
      const loan = _.find(
        cashflows.filter((x) => x.type === LOAN_CASHFLOW),
        { id: +loanId }
      );
      return loan ? loan.type + loanId.toString() : null;
    }
    if (hedgeId) {
      const hedge = _.find(
        cashflows.filter((x) => this.isHedge(x.type)),
        { id: +hedgeId }
      );
      return hedge ? hedge.type + hedgeId.toString() : null;
    }
    if (!_.isEmpty(cashflows)) {
      return cashflows[0].type + cashflows[0].id;
    }
  };
  shouldShowOverrideButton = (selectedCashflowObject, selectedCashflows) => {
    const { authentication, guestPermission } = this.props;

    if (this.state.showQuotes && selectedCashflowObject) {
      if (selectedCashflowObject.type !== LOAN_CASHFLOW || this.state.quoteId2) return false;
    }
    const permissionCheck = guestPermissionHelper.enableEditButton(authentication, guestPermission, GUEST_PERMISSIONS.EDIT);
    return permissionCheck && selectedCashflowObject && this.isNotCombined(selectedCashflowObject) && selectedCashflows.length > 0;
  };
  isNotCombined = (x) => {
    return x.type !== COMBINED_CASHFLOW;
  };

  getExportFunction = (cashflow) => {
    if (cashflow) {
      if (cashflow.type === COMBINED_CASHFLOW) {
        return () =>
          this.props.downloadCombinedCashflows({
            dealId: this.state.dealId,
            isQuote: this.state.showQuotes,
            cashflow
          });
      } else if (cashflow.type === LOAN_CASHFLOW) {
        return () =>
          this.props.downloadLoanCashflows({
            dealId: this.state.dealId,
            loanId: cashflow.id
          });
      } else {
        return () =>
          this.props.downloadHedgeCashflows({
            dealId: this.state.dealId,
            hedgeId: cashflow.id,
            cashflowType: cashflow.type,
            fromQuote: this.state.showQuotes,
            cashflow
          });
      }
    }
    return null;
  };

  getDebtValuationCashflow = (cashflowValue, callback) => {
    const loanId = cashflowValue.indexOf("DV_LOAN_CASHFLOW") !== -1 ? cashflowValue.split("DV_LOAN_CASHFLOW")[1] : cashflowValue;
    return this.props.downloadDebtValuationResultsByLoanId({
      loanId,
      valuationDate: this.state.valuationDate,
      callback
    });
  };

  render() {
    const { dealId, value, selectedCashflows, isResetModalOpen, isOverrideCashflowModalOpen } = this.state;
    const dealName = this.state.dealName;
    let cashflowRecords = this.getCashflows();
    let selectedCashflowObject = this.getSelectedValueCashflowObject(value, cashflowRecords);
    let cashflows = this.generateTabs(cashflowRecords);
    let exportFunction = this.getExportFunction(selectedCashflowObject);

    let debtValuationData = null;
    if (this.state.isDVStateActive) {
      debtValuationData = this.generateDVData(value, cashflowRecords);
    }

    return (
      <Grid container style={{ margin: "0 auto", "max-width": "1400px", "padding-top": "19px", "min-width": "1400px" }}>
        {this.state.showQuotes && (
          <>
            <SecondaryButton
              style={{ borderRight: "1px solid #cccccc" }}
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              Go Back
            </SecondaryButton>
            <SecondaryButton
              onClick={() => {
                window.location.reload();
              }}
            >
              Refresh
            </SecondaryButton>
          </>
        )}
        <div style={{ display: "flex", flexWrap: "wrap", width: "100%", alignItems: "flex-start" }}>
          <div style={{ flexBasis: "50%", position: "relative", height: "100%" }}>
            <ButtonText
              style={{ "padding-left": "0px", position: "absolute", bottom: 16, left: 0 }}
              onClick={() => this.props.history.goBack()}
              iconName={"arrow_forward"}
              label={"Go Back"}
              reverse={true}
            />
          </div>
          <div style={{ paddingTop: "10px", flexBasis: "50%", marginLeft: "auto", flex: "0 1 auto", flexGrow: 0, textAlign: "right", alignItems: "right" }}>
            <Card
              style={{
                boxShadow: "0px 10px 20px rgba(173,174,174, 0.25)",
                fontFamily: "Work Sans",
                border: "1px solid #DADCE0",
                fontWeight: "500",
                fontSize: "24px",
                lineHeight: "28px",
                height: "54px"
              }}
            >
              <CardContent style={{ paddingLeft: "48px", paddingRight: "48px" }}>
                <Typography
                  style={{
                    fontFamily: "Work Sans",
                    fontWeight: "500",
                    fontSize: "24px",
                    lineHeight: "28px"
                  }}
                  align="center"
                >
                  {dealName && (
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.push(`/deal/${dealId}`);
                      }}
                    >
                      {dealName}
                    </span>
                  )}
                </Typography>
              </CardContent>
            </Card>
          </div>
        </div>
        {cashflows && (
          <div style={{ paddingTop: "15px", display: "flex", flexWrap: "wrap", width: "100%", alignItems: "flex-start" }}>
            <div style={{ marginRight: "32px" }}>
              <ButtonMenu
                selected={value}
                name="Deal Cashflows"
                handleSelection={(data) => {
                  this.handleChange(null, data);
                  this.handleDebtValuationToggle(false);
                }}
                items={cashflows[COMBINED_CASHFLOW]}
              />
            </div>
            <div style={{ marginRight: "32px" }}>
              <ButtonMenu
                selected={value}
                name="Loan Cashflows"
                handleSelection={(data) => {
                  this.handleChange(null, data);
                  this.handleDebtValuationToggle(false);
                }}
                items={cashflows[LOAN_CASHFLOW]}
              />
            </div>
            {cashflows[HEDGE_CASHFLOW] && cashflows[HEDGE_CASHFLOW][0] && (
              <div style={{ marginRight: "32px" }}>
                <ButtonMenu
                  selected={value}
                  name="Hedge Cashflows"
                  handleSelection={(data) => {
                    this.handleChange(null, data);
                    this.handleDebtValuationToggle(false);
                  }}
                  items={cashflows[HEDGE_CASHFLOW]}
                />
              </div>
            )}
            {this.props.isDVActive && (
              <div style={{ marginRight: "32px" }}>
                <ButtonMenu
                  selected={value}
                  name="Debt Valuation"
                  handleSelection={(data) => {
                    this.handleChange(null, data);
                    this.handleDebtValuationToggle(true);
                  }}
                  items={cashflows[DEBT_VALUATION]}
                />
              </div>
            )}
          </div>
        )}
        {this.props.isDVActive && debtValuationData && (
          <StyledDebtValuationContainer in={this.state.isDVStateActive} addMargin={this.state.isDVStateActive}>
            <StyledDebtValuationMetricContainer>
              <DVMetric>
                <DVTitleLabel>Debt Valuation</DVTitleLabel>
                <DVAsOfDateLabel>{`Rates as of ${
                  debtValuationData.ratesAsOf ? moment(debtValuationData.ratesAsOf).format("MM/DD/YYYY") : null
                }`}</DVAsOfDateLabel>
                <DVLink
                  onClick={() => {
                    this.props.history.push("/debtvaluation");
                  }}
                >
                  Jump to Dashboard
                  <MaterialIcon iconName="north_east" style={{ marginLeft: "10px" }} />
                </DVLink>
              </DVMetric>
              <DVMetricDivider />
              <DVMetric>
                <DVMetricValue>{numeral(debtValuationData.debtValue).format("$0,0")}</DVMetricValue>
                <DVMetricLabel>Debt Value</DVMetricLabel>
              </DVMetric>
              <DVMetricDivider />
              <DVMetric>
                <DVMetricValue>{numeral(debtValuationData.parValue).format("$0,0")}</DVMetricValue>
                <DVMetricLabel>Par Value</DVMetricLabel>
              </DVMetric>
              <DVMetricDivider />
              <DVMetric>
                <DVMetricValue isNegative={debtValuationData.discountPremium < 0}>{numeral(debtValuationData.discountPremium).format("$0,0")}</DVMetricValue>
                <DVMetricLabel>Premium/Discount</DVMetricLabel>
              </DVMetric>
            </StyledDebtValuationMetricContainer>
          </StyledDebtValuationContainer>
        )}
        <div style={{ display: "flex", flexWrap: "row", paddingTop: "10px", width: "100%", marginBottom: "11px" }}>
          <OverrideButtonWrapper style={{ marginLeft: "auto" }}>
            {this.shouldShowOverrideButton(selectedCashflowObject, selectedCashflows) && (
              <SecondaryButton style={{ fontSize: "20px", lineHeight: "23px", textTransform: "capitalize" }} onClick={this.openOverrideCashflowModal}>
                Override
              </SecondaryButton>
            )}
            {_.get(selectedCashflowObject, "isOverridden", false) && !this.props.authentication.isGuest && (
              <SecondaryButton style={{ fontSize: "20px", lineHeight: "23px", textTransform: "capitalize" }} onClick={this.openResetModal}>
                Reset
              </SecondaryButton>
            )}
          </OverrideButtonWrapper>
          {this.state.isDVStateActive && (
            <OverrideButtonWrapper style={{ marginLeft: "auto" }}>
              <SecondaryButton style={{ fontSize: "20px", lineHeight: "23px", textTransform: "capitalize" }} onClick={this.handleDebtValuationSettingsModal}>
                Settings
              </SecondaryButton>
            </OverrideButtonWrapper>
          )}
          <OverrideButtonWrapper>
            <SecondaryButton
              style={{ fontSize: "20px", lineHeight: "23px", textTransform: "capitalize" }}
              onClick={() => {
                value && value.indexOf("DV") !== -1 ? this.setState({ isExportModalOpen: true }) : exportFunction();
              }}
            >
              Download
            </SecondaryButton>
          </OverrideButtonWrapper>
        </div>

        <div className="hide-scrollbar" style={tableContainerStyles}>
          {this.generateTabContainers(value, cashflowRecords)}
        </div>
        <SimpleConfirmDialog
          title="Confirm Reset"
          message="You are about to reset cashflows to the system-calculated values. Are you sure you want to do this?"
          noText="NO"
          yesText="YES, RESET"
          modalOpen={isResetModalOpen}
          handleNo={this.closeResetModal}
          handleYes={() => {
            this.handleResetOverride(selectedCashflowObject);
          }}
        />
        <OverrideCashflowsModal
          dealId={dealId}
          onOverride={(file) => this.handleOverride(file, selectedCashflowObject)}
          onClose={this.closeOverrideCashflowModal}
          cashflowType={_.get(selectedCashflowObject, "type", null)}
          isOpen={isOverrideCashflowModalOpen}
          downloadElements={this.renderDownloadElements(selectedCashflowObject)}
        ></OverrideCashflowsModal>
        <DebtValuationSettingsModal
          isOpen={this.state.isDebtValuationSettingsModalOpen}
          handleClose={this.handleDebtValuationSettingsModal}
          debtValuationSettings={debtValuationData ? debtValuationData.debtValuationSettings : null}
          refreshCashflows={() => this.props.getDealCashflows({ dealId: dealId, subKey: dealId })}
        />
        <DebtValuationExportModal
          isOpen={this.state.isExportModalOpen}
          onClose={() => this.setState({ isExportModalOpen: false })}
          onExport={(callback) => {
            this.getDebtValuationCashflow(value, callback);
          }}
          authentication={this.props.authentication}
          valuationDate={this.state.valuationDate}
          handleDatePicker={(date) => {
            this.setState({ valuationDate: date });
          }}
        />
      </Grid>
    );
  }
}

const mapStateToProps = ({ deal, fund, cashflows, authentication, debtValuation }) => ({
  dealNames: deal.dealNames,
  fundNames: fund.fundNames,
  cashflows: cashflows.dealCashflows,
  uploadResult: cashflows.uploadResult,
  authentication,
  guestPermission: cashflows.guestPermission,
  isDVActive: cashflows.isDVActive,
  ratesAsOfForLoans: debtValuation.ratesAsOfForLoans
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getDealName,
    getFundName,
    getQuoteCashflows,
    getCombinedQuoteCashflows,
    getDealCashflows,
    getRatesAsOfForLoans,
    resetLoanCashflowOverrides,
    resetHedgeCashflowOverrides,
    downloadLoanCashflows,
    downloadHedgeCashflows,
    downloadCombinedCashflows,
    uploadLoanCashflowsOverride,
    uploadHedgeCashflowsOverride,
    getDebtValuationActivationStatus,
    downloadDebtValuationResultsByLoanId
  }),
  withStyles(styles)
)(CashflowsPage);